export const payroll = {
  'payroll.title': 'مسيّر الرواتب',
  'payroll.subtitle': 'مسودة ← اعتماد ← دفع. من يُعِدّ المسيّر لا يعتمده.',
  'payroll.new': 'مسيّر شهر جديد',
  'payroll.col.month': 'الشهر',
  'payroll.col.staff': 'الموظفون',
  'payroll.col.gross': 'الإجمالي',
  'payroll.col.deductions': 'الاستقطاعات',
  'payroll.col.net': 'الصافي',
  'payroll.empty': 'لا مسيّرات رواتب بعد',
  'payroll.emptyBody': 'أنشئ مسيّر الشهر ليُحتسب راتب كل موظف من عقده ومخصصاته وغيابه وأقساط سُلفه.',
  'payroll.create.title': 'إنشاء مسيّر رواتب',
  'payroll.create.body': 'يُحتسب المسيّر كمسودة يمكن إعادة احتسابها حتى الاعتماد.',
  'payroll.create.month': 'شهر الرواتب',
  'payroll.create.submit': 'احتساب المسيّر',
  'payroll.create.done': 'أُنشئ مسيّر {month}',
  'payroll.create.exists': 'يوجد مسيّر لهذا الشهر بالفعل.',
  'payroll.create.openExisting': 'فتح المسيّر الموجود',
  'payroll.run.title': 'رواتب {month}',
  'payroll.run.employerCost': 'حصة صاحب العمل من الضمان {amount} (لا تُخصم من الرواتب)',
  'payroll.run.shortfallTotal': '{amount} من أقساط السُّلف رُحّل للشهر القادم بسبب الحد القانوني',
  'payroll.run.paidCount': 'دُفع {paid} من {total}',
  'payroll.run.recompute': 'إعادة الاحتساب',
  'payroll.run.recomputed': 'أُعيد احتساب المسيّر',
  'payroll.run.delete': 'حذف المسودة',
  'payroll.run.deleteTitle': 'حذف مسودة المسيّر؟',
  'payroll.run.deleteBody': 'تُحذف قسائم هذه المسودة. يمكنك إنشاؤها من جديد.',
  'payroll.run.deleted': 'حُذفت المسودة',
  'payroll.run.approve': 'اعتماد المسيّر',
  'payroll.run.approveTitle': 'اعتماد مسيّر {month}؟',
  'payroll.run.approveBody': 'تُقفل القسائم، وتُسجَّل أقساط السُّلف كمخصومة، ويُرحَّل ما لم يسمح به الحد القانوني إلى الشهر القادم.',
  'payroll.run.approved': 'اعتُمد المسيّر',
  'payroll.run.preparerNotice': 'أعددت هذا المسيّر، لذلك يعتمده المالك أو مدير آخر (فصل المهام).',
  'payroll.run.waitingApproval': 'بانتظار اعتماد المدير أو المالك.',
  'payroll.run.draftHint': 'مسودة: عدّل الغياب أو العقود ثم أعد الاحتساب قبل الاعتماد.',
  'payroll.run.payAll': 'دفع الرواتب المتبقية',
  'payroll.run.allPaid': 'دُفعت كل الرواتب',
  'payroll.run.noPayslips': 'لا قسائم في هذا المسيّر',
  'payroll.run.noPayslipsBody': 'لا يوجد موظفون بعقود سارية في هذا الشهر.',
  'payroll.col.employee': 'الموظف',
  'payroll.col.base': 'الأساسي',
  'payroll.col.allowances': 'المخصصات',
  'payroll.col.absence': 'غياب',
  'payroll.col.penalties': 'عقوبات',
  'payroll.col.ss': 'ضمان',
  'payroll.col.tax': 'ضريبة',
  'payroll.col.advance': 'قسط السلفة',
  'payroll.col.paid': 'الدفع',
  'payroll.carried': 'رُحّل {amount} للشهر القادم (الحد القانوني {cap})',
  'payroll.paid': 'مدفوع',
  'payroll.unpaid': 'غير مدفوع',
  'payroll.pay': 'دفع',
  'payroll.viewPayslip': 'القسيمة',
  'payroll.pay.title': 'دفع راتب {name}',
  'payroll.pay.amount': 'الصافي المستحق',
  'payroll.pay.method': 'طريقة الدفع',
  'payroll.pay.account': 'من حساب',
  'payroll.pay.reference': 'رقم المرجع',
  'payroll.pay.referenceHint': 'رقم الحوالة أو العملية',
  'payroll.pay.submit': 'تسجيل الدفع',
  'payroll.pay.done': 'سُجّل دفع راتب {name}',
  'payroll.payAll.title': 'دفع الرواتب المتبقية',
  'payroll.payAll.body': '{n} غير مدفوعة بصافي {amount}. تُدفع واحدة تلو الأخرى؛ إن توقف الاتصال أعد المحاولة بأمان.',
  'payroll.payAll.referenceHint': 'مرجع واحد للدفعة (مثل رقم كشف التحويل)',
  'payroll.payAll.progress': 'دُفع {done} من {total}',
  'payroll.payAll.failed': 'توقف الدفع عند {name}: {error}',
  'payroll.payAll.done': 'دُفعت {n}',
  'payroll.payslip.title': 'قسيمة راتب',
  'payroll.payslip.heading': 'قسيمة راتب · {month}',
  'payroll.payslip.earnings': 'الاستحقاقات',
  'payroll.payslip.deductions': 'الاستقطاعات',
  'payroll.payslip.gross': 'إجمالي الاستحقاقات',
  'payroll.payslip.totalDeductions': 'إجمالي الاستقطاعات',
  'payroll.payslip.net': 'صافي الراتب',
  'payroll.payslip.noDeductions': 'لا استقطاعات',
  'payroll.payslip.info': 'معلومات',
  'payroll.payslip.cap': 'حد الاستقطاع القانوني {rate} من الأجر ({amount})',
  'payroll.payslip.employerSs': 'حصة صاحب العمل من الضمان {amount} (لا تُخصم)',
  'payroll.payslip.shortfall': 'رُحّل {amount} من قسط السلفة للشهر القادم',
  'payroll.payslip.payment': 'الدفع',
  'payroll.payslip.paidOn': 'دُفع {method} في {date}',
  'payroll.payslip.reference': 'المرجع {ref}',
  'payroll.payslip.notPaid': 'لم يُدفع بعد',
  'payroll.payslip.back': 'المسيّر',
  'payroll.payslip.signature': 'توقيع المستلم',
  'payroll.footnote': 'تُحتسب الضريبة والضمان بنسب الدولة المؤرَّخة وتُؤكَّد مع محاسب محلي.',
  'payroll.line.BASE': 'الراتب الأساسي',
  'payroll.line.ABSENCE': 'غياب {n}',
  'payroll.line.SOCIAL_SECURITY': 'الضمان الاجتماعي',
  'payroll.line.INCOME_TAX': 'ضريبة الدخل',
  'payroll.line.EMPLOYER_SOCIAL_SECURITY': 'حصة صاحب العمل من الضمان',
  'payroll.line.ADVANCE': 'قسط السلفة',
  'payroll.line.ADVANCE_DEFERRED': 'قسط السلفة (مؤجل)',
  'payroll.staffCount': 'عدد الموظفين: {n}',
  'payroll.payslip.paidBy': 'صرفه: {name}',
  'payroll.run.preparedBy': 'أعدّه {name}',
  'payroll.run.approvedBy': 'اعتمده {name}',
} as const;
